// @ts-nocheck
import React from 'react';
import { useActions } from '../../../hooks/useActions';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { IAddEntityModalParameters } from '../../../models/AddEntityModalParameters';
import { ModalTypes } from '../../../const/ModalTypes';
import KanbanButton from '../../KanbanButton';

interface ProjectsAddCardLinkProps {
  laneId: string;
  onClick: () => void;
}

export const ProjectsAddCardLink = React.memo(({ laneId }: ProjectsAddCardLinkProps) => {
  const { openProjectsModal } = useActions();
  const { project, currentProjectReleaseId } = useTypedSelector((state) => state.project);

  const phase = project.projectPhases.find((phase) => phase.id.toString() === laneId);
  const showAddCardButton = phase.phaseTasks.length <= 0;

  if (!showAddCardButton) return <></>;

  const modalParameters: IAddEntityModalParameters = {
    headerPlaceholder: `Add card to ${phase.phaseName} phase`,
    textPlaceholder: 'Enter a title for a new card...',
    addEntityButtonPlaceholder: 'Add card',
    addEntitiesButtonPlaceholder: 'Add # cards',
    cancelEntityButtonPlaceholder: 'Cancel',
    taskPhaseId: Number(laneId),
    projectId: project.id,
    projectReleaseId: currentProjectReleaseId,
  } as IAddEntityModalParameters;

  const openModal = () => {
    openProjectsModal(modalParameters, null, null, ModalTypes.CreateTaskModal);
  };

  return <KanbanButton onClick={openModal} />;
});
